/* import __COLOCATED_TEMPLATE__ from './help-modal-button.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Utils from '../utils/utils';
import Constants from '../utils/constants';
import kebabCase from 'lodash.kebabcase';
import { htmlSafe } from '@ember/template';

import RootSumSquaredErrorHelp from './help/root-sum-squared-error';
import WorstCaseErrorHelp from './help/worst-case-error';

const HELP_CLASSES = {
  'root-sum-squared-error': RootSumSquaredErrorHelp,
  'worst-case-error': WorstCaseErrorHelp,
};

export default class HelpModalButton extends Component {
  @service intl;
  @service('aditools-analytics') analytics;

  @action showHelpModal() {
    let modalData;
    if (this.args.getHelpModalData) modalData = this.args.getHelpModalData(this.args.type);
    else {
      modalData = {
        text: htmlSafe(this.intl.t(`help-modal.${this.args.type}.text`)),
        title: htmlSafe(this.intl.t(`help-modal.${this.args.type}.title`)),
        componentName: kebabCase(this.args.type),
        componentClass: HELP_CLASSES[kebabCase(this.args.type)],
        helpText: this.args.type,
      };
    }

    this.args.model.modalHandler.show(Constants.MODAL_TYPES.HELP.value, modalData || {});

    this.analytics.setWebEvent(Utils.getToolName(), `openHelpDialog`, modalData.helpText);
  }
}
